import React from "react"
import { Link, graphql } from "gatsby"
import { Container, Row, Col } from "react-bootstrap"
import Title from "../common/title"
import parse from "html-react-parser"
import Media from "../common/media"
import StyledButton from "../common/styledButton"

const BlockMedias = ({ content }) => {
  return (
    <div className="blk-media-desc">
      <Container>
        <Row className="justify-content-left alignLeft">
          <Col md={6} xs={12}>
            <div className="blk-description-content ml-50">
              <Title text={content.block_medias_text_title} />
              <div
                className="description animTxt animTxt_3"
                style={{ paddingBottom: "50px" }}
              >
                <br /> {parse(content.block_medias_text_description.processed)}
                <div className="btnOffers">
                  {content.block_medias_text_link && (
                    <StyledButton
                      type={'link'}
                      title={content.block_medias_text_link.title}
                      path={content.block_medias_text_link.url}
                    />
                  )}
              </div>
              </div>
              <div className="animImgTop">
                {content.relationships.block_medias_text_medias.length > 0 &&
                  content.relationships.block_medias_text_medias[1] && (
                    <Media
                      media={content.relationships.block_medias_text_medias[1]}
                    />
                  )}
              </div>
            </div>
          </Col>
          <Col
            style={{ paddingTop: "60px" }}
            md={6}
            xs={12}
            className="animImgTop"
          >
            <div className="blkMedia">
              {content.relationships.block_medias_text_medias.length > 0 &&
                content.relationships.block_medias_text_medias[0] && (
                  <Media
                    media={content.relationships.block_medias_text_medias[0]}
                  />
                )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export const query = graphql`
  fragment descriptionMedias on paragraph__block_medias_text {
    internal {
      type
    }
    block_medias_text_title
    block_medias_text_description {
      processed
    }
    block_medias_text_link {
      url
      title
    }
    relationships {
      block_medias_text_medias {
        ...getImageVideo
      }
    }
  }
`
export default BlockMedias
